var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrap"},[_vm._m(0),_c('div',{staticClass:"content"},[(!_vm.loading)?_c(_vm.resolvedComponent,{tag:"component"}):_vm._e()],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/logo.svg"),"alt":"Политические лидеры"}})])
}]

export { render, staticRenderFns }